export default __webpack_public_path__ + "static/media/logo_next_day.08726185.png";